import type { ReactNode } from 'react'

import clsx from 'clsx'

import '@cosmos/embed/embed.css'

type EmbedProps = {
  children: ({ embedItemClassName }: { embedItemClassName: string }) => ReactNode
  size: '21by9' | '16by9' | '4by3' | '1by1'
  className?: string
}

const Embed = ({ children, size, className }: EmbedProps) => {
  const classes = clsx(`hot-embed--${size}`, className)

  return (
    <hot-embed class={classes}>{children({ embedItemClassName: 'hot-embed__item' })}</hot-embed>
  )
}

export default Embed
